import {openDeleteDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {
  usePostTireOrderArchiveMutation,
  usePostTireOrderDeleteMutation,
  usePostTireOrderRestoreMutation,
} from '@dms/api/core';
import {testIds, tiresInventoryRoutes} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function TireOrderOverview() {
  const navigate = useNavigate();

  const [archiveTireOrder] = usePostTireOrderArchiveMutation();
  const [restoreTireOrder] = usePostTireOrderRestoreMutation();
  const [deleteTireOrder] = usePostTireOrderDeleteMutation();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData}) => {
    const tireOrderId = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('redirectDetail', () => {
        navigate(
          composePath(tiresInventoryRoutes.tireOrderDetail, {
            params: {id: tireOrderId},
            queryParams: {source: 'tire-orders'},
          })
        );
      })
      .with('archive', () =>
        archiveTireOrder({orderId: tireOrderId})
          .unwrap()
          .then(() => refreshData())
          .catch(handleApiError)
      )
      .with('restore', () =>
        restoreTireOrder({orderId: tireOrderId})
          .unwrap()
          .then(() => refreshData())
          .catch(handleApiError)
      )
      .with('delete', () =>
        openDeleteDialog({
          onConfirm: () =>
            deleteTireOrder({orderId: tireOrderId})
              .unwrap()
              .then(() => refreshData())
              .catch(handleApiError),
        })
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <DmsDataGrid
      gridCode="tire-order"
      actionCallback={actionCallback}
      data-testid={testIds.tiresInventory.tireOrders('grid')}
    />
  );
}
